import Vue from 'vue'
import API from './api'
// import tool from './utils'
import router from '../router/index'
import store from '@/store'

var fetch = {
  // 退出登录
  loginOut() {
    Vue.prototype.post(API.webapp.user.logout)
    store.dispatch('setToken', false)
    store.dispatch('setUserInfo', {})
    router.push({ path: '/login' })
  },
  // 获取租户id
  async getTenantByDomainArray(callback) {
    const dev = process.env.NODE_ENV == 'development'
    const d = await Vue.prototype.post(Vue.prototype.$api.common.getTenantByDomainArray, {
      // domainArray: dev ? 'app.11ready.com' : window.location.host
      domainArray: dev ? '10.0.0.26:32019' : window.location.host
    })
    // const d = await Vue.prototype.post(Vue.prototype.$api.home.getUniversityCode, {
    //   domain: dev ? "10.0.0.52:3522" : window.location.host
    // });
    if (d.code === 0) {
      Vue.prototype.$common.setLocalStorage('labelName', d.data2.labelName)
      Vue.prototype.$common.setLocalStorage('tenantId', d.data2.tenantId)
      window.document.title = d.data2.labelName
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = d.data2.labelLogo
      document.getElementsByTagName('head')[0].appendChild(link)
      // callback()
    }
  },
  async addExceptionLog(data) {
    const d = await Vue.prototype.post(Vue.prototype.$api.common.addExceptionLog, {
      ...data
      // ...JSON.parse(sessionStorage.getItem('response'))
    })
    if (d.code === 0) {
      sessionStorage.setItem('response', '')
    }
  },
  async getAllResumes() {
    return new Promise((resolve, reject) => {
      Vue.prototype.post(Vue.prototype.$api.resume.getAllResumes, {
        userId: Vue.prototype.$common.getLocalStorage('userInfo').userId
      }).then(res => {
        store.dispatch('objjobhunterinfo', res.data)

        resolve(res.data)
      })
    })
  }
  // //获取赛道id
  // async getTrackId (callback) {
  //   var trackId = tool.getSessionStorage('trackId'),
  //     queryTrackId = Vue.prototype.$common.getParam('trackId');
  //   if (queryTrackId) {
  //     tool.setSessionStorage('trackId', queryTrackId)
  //     callback()
  //   } else if (!trackId && !queryTrackId) {
  //     const dev = process.env.NODE_ENV == 'development'
  //     var d = await Vue.prototype.post(API.common.getTrackId, {
  //       // www.zhzjcxcy.com http://fjut.qcwlyss.com/#/login
  //       //http://ptb.zhzjcxcy.comhttp://fjxxzyjsxy.qcwlyss.com/#/selectMatch
  //       domain: dev ? 'ptb.zhzjcxcy.com' : window.location.host
  //       // domain: 'www.zhzjcxcy.com'
  //       //http://fjxxzyjsxy.qcwlyss.com/#/
  //       // domain: 'ptb.zhzjcxcy.com'
  //       //http://fjxxzyjsxy.qcwlyss.com/#/selectMatch
  //       // http://fjxxzyjsxy.qcwlyss.com/#/
  //     })
  //     if (d.code === 0) {
  //       tool.setSessionStorage('trackId', d.data)
  //       callback()
  //     }
  //   } else {
  //     callback()
  //   }
  // },
}

Vue.prototype.$fetch = fetch
export default fetch



// WEBPACK FOOTER //
// ./src/axios/fetch.js